import { Server, Globe, Terminal } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { TokenType } from "@/types/token";

interface TokenTypeBadgeProps {
  type: TokenType;
  className?: string;
}

export function TokenTypeBadge({ type, className }: TokenTypeBadgeProps) {
  const Icon = type === "backend" ? Server : type === "cli" ? Terminal : Globe;
  const variant =
    type === "backend" ? "default" : type === "cli" ? "outline" : "secondary";

  return (
    <Badge variant={variant} className={cn("gap-1 font-mono", className)}>
      <Icon className="h-3 w-3" />
      {type}
    </Badge>
  );
}
